import React from 'react';
import PropTypes from 'prop-types';

// Styles
import './table.scss';

function Table({ listOfHeaders, listOfRows, importedClasses }) {
    const tableClasses = `table ${importedClasses}`;
    return (
        <table className={tableClasses}>
            { listOfHeaders &&
                <thead className="tableHeader">
                    <tr>
                        {
                            listOfHeaders.map((header) => {
                                const headerClasses = `table__cell table__cell--header ${header.importedClasses || ''}`;
                                return (
                                    <th
                                        {...header.ariaProps}
                                        key={header.key}
                                        className={headerClasses}
                                        colSpan={header.colSpan}>
                                        {header.content}
                                    </th>
                                );
                            })
                        }
                    </tr>
                </thead>
            }
            { listOfRows && listOfRows.length > 0 &&
                <tbody>
                    {listOfRows}
                </tbody>
            }
        </table>
    );
}

Table.defaultProps = {
    importedClasses: ''
};

Table.propTypes = {
    listOfHeaders: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        importedClasses: PropTypes.string,
        colSpan: PropTypes.number,
        content: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
    })),
    listOfRows: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object, PropTypes.string])),
    importedClasses: PropTypes.string
};

export default Table;



// WEBPACK FOOTER //
// ./components/table/table.js